export const GOOGLE_MAP_URL =
  'https://maps.googleapis.com/maps/api/js?key=AIzaSyBIlzEDKwpEwAzV5nm5qUJA1Dzd-mjnZlA&v=3.exp&libraries=geometry,drawing,places';
export const ROUTE_CHECK_IN = '/checkIn';
export const DD_MM_YYYY_HH_MM = 'DD/MM/YYYY HH:mm';
